import * as React from 'react';
import { ConversationApiProvider } from './components/ConversationApiProvider.js'
import { ConversationEditorProvider } from './components/ConversationEditorProvider.js'
import { ConversationOptionsProvider } from './components/ConversationOptionsProvider.js'
import { ConversationOverlay } from './components/ConversationOverlay.js'
import { ConversationTextsProvider } from './components/LocaleProvider.js'
import { Root } from './components/Root.js'
import { ScrollApiProvider } from './components/ScrollApiProvider.js'
import { WormholeIdProvider } from './components/WormholeIdProvider.js'
import type { ConversationProps } from './types.js'

export function Conversation(props: ConversationProps) {
  const {
    children,
    localeText,
    slotProps: { root } = {},
    api,
  } = props

  return (
    <ConversationTextsProvider localeText={localeText}>
      <ScrollApiProvider>
        <ConversationApiProvider api={api}>
          <ConversationOptionsProvider {...props}>
            <ConversationEditorProvider>
              <WormholeIdProvider>
                <Root {...root} data-tidal="Conversation">
                  {children}
                  <ConversationOverlay />
                </Root>
              </WormholeIdProvider>
            </ConversationEditorProvider>
          </ConversationOptionsProvider>
        </ConversationApiProvider>
      </ScrollApiProvider>
    </ConversationTextsProvider>
  )
}
